export enum StorageName {
    AccessToken = "accessToken",
    DocumentsListFilterParams = "documentsListFilterParams",
    DocumentsListPaginationStorePreviousPage = "documentsListPaginationStorePreviousPage",
    DocumentsListPaginationStoreSearchAfter = "documentsListPaginationStoreSearchAfter",
    AppLanguage = "appLanguage",
    Theme = "theme",
    DocumentSortStore = "documentSortStore",
    DocumentPageSize = "documentPageSize",
    LoginHistory = "loginHistory"
}
